import { combineReducers } from "@reduxjs/toolkit";
import portalSearchTableReducer from "./portalSearchTable";
import educationSystemsReducer from "./educationSystemsSearchData";

const viewDataReducers = combineReducers({
  portalSearchTable: portalSearchTableReducer,
  educationSystems: educationSystemsReducer,
});

export default viewDataReducers;
